class NostoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const fallbackProducts = JSON.parse(this.els.products.element.innerText)

    // Using a setTimeout here as the customerPrivacy object is not available immediately
    setTimeout(() => {
      const { marketing } =
        window.Shopify.customerPrivacy.currentVisitorConsent()

      if (!!marketing === false && fallbackProducts.length > 0) {
        this.els.nosto.element.innerHTML = this.els.fallback.element.innerHTML
      }

      this.els.fallback.element.remove()
    }, 1000)
  }
}

if (!customElements.get('nosto-carousel')) {
  customElements.define('nosto-carousel', NostoCarousel)
}
